import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './BecomeSellerPage.module.css';

const PERKS = [
  { icon: '🛍️', title: 'Reach 2M+ buyers', desc: 'Your products are visible to millions of Nigerians shopping on Vendly every day.' },
  { icon: '💸', title: 'Fast payouts', desc: 'Get paid to your bank account within 24–48 hours of confirmed delivery.' },
  { icon: '🆓', title: 'Free to list', desc: 'No listing fees. We only take a small commission when you make a sale.' },
  { icon: '📱', title: 'Upload via Telegram', desc: 'List products in minutes using our Telegram seller bot — no technical skills needed.' },
  { icon: '🛡️', title: 'Secure transactions', desc: 'All payments are handled by Vendly. No risk of fraud or chargeback.' },
  { icon: '📊', title: 'Sales dashboard', desc: 'Track your orders, earnings and product performance from your seller profile.' },
];

const STEPS = [
  { n: '01', title: 'Create your seller account', desc: 'Fill in your business details and verification info. Takes about 5 minutes.' },
  { n: '02', title: 'Admin reviews your application', desc: 'Our team reviews all applications within 24 hours to maintain quality.' },
  { n: '03', title: 'Get your Seller ID', desc: 'Once approved you receive a unique 7-character Seller ID.' },
  { n: '04', title: 'Start uploading & earning', desc: 'Use your Seller ID on the Telegram bot or website to list products instantly.' },
];

export default function BecomeSellerPage() {
  const { isLoggedIn } = useAuth();

  return (
    <div className={styles.page}>

      {/* Hero */}
      <div className={styles.hero}>
        <div className={styles.heroBadge}>🇳🇬 Built for Nigerian sellers</div>
        <h1 className={styles.heroTitle}>
          Grow your business<br />
          <span className={styles.accent}>with Vendly</span>
        </h1>
        <p className={styles.heroSub}>
          Join 10,000+ verified sellers reaching millions of buyers across Nigeria. List products in minutes, get paid fast.
        </p>
        <Link
          to={isLoggedIn ? '/seller/apply' : '/login?next=/seller/apply'}
          className={styles.heroCta}
        >
          Create seller account →
        </Link>
        {!isLoggedIn && (
          <p className={styles.heroNote}>You'll be asked to sign in first</p>
        )}
      </div>

      {/* Stats */}
      <div className={styles.statsRow}>
        {[['2M+','Active buyers'],['10K+','Verified sellers'],['24hrs','Review time'],['0%','Listing fee']].map(([n,l]) => (
          <div key={l} className={styles.stat}>
            <span className={styles.statNum}>{n}</span>
            <span className={styles.statLabel}>{l}</span>
          </div>
        ))}
      </div>

      {/* Perks */}
      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Why sell on Vendly?</h2>
        <div className={styles.perksGrid}>
          {PERKS.map(p => (
            <div key={p.title} className={styles.perkCard}>
              <span className={styles.perkIcon}>{p.icon}</span>
              <h3 className={styles.perkTitle}>{p.title}</h3>
              <p className={styles.perkDesc}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* How it works */}
      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>How it works</h2>
        <div className={styles.stepsGrid}>
          {STEPS.map(s => (
            <div key={s.n} className={styles.stepCard}>
              <span className={styles.stepN}>{s.n}</span>
              <div className={styles.stepLine} />
              <h3 className={styles.stepTitle}>{s.title}</h3>
              <p className={styles.stepDesc}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom CTA */}
      <div className={styles.cta}>
        <h2 className={styles.ctaTitle}>Ready to start selling?</h2>
        <p className={styles.ctaSub}>Create your seller account in 5 minutes.</p>
        <Link
          to={isLoggedIn ? '/seller/apply' : '/login?next=/seller/apply'}
          className={styles.ctaBtn}
        >
          Get started — it's free
        </Link>
      </div>
    </div>
  );
}
